import { useState } from 'react';

import Container from '../components/Container';
import { SuperAdminHeader } from '../components/SuperAdminHeader';
import Card from '../components/Card';
import PlanCard from '../components/PlanCard';
import PlanEditModal from '../components/PlanEditModal';

import { usePlans } from '../contexts/Plans';

export default function SuperAdminPlanSettings() {
  const { plansById } = usePlans();
  const [modalInput, setModalInput] = useState<string>();

  return (
    <Container>
      <SuperAdminHeader />

      <Card className="relative px-6 py-8 mb-8 overflow-x-auto md:py-12 md:px-10">
        <div className="flex flex-col items-center w-full lg:items-stretch lg:flex-row">
          {Object.keys(plansById).map((planId) => (
            <PlanCard
              key={`plan-${planId}`}
              planId={planId}
              plan={plansById[planId]}
              className="w-full max-w-xm mb-6 lg:mr-5"
              onSelect={() => setModalInput(planId)}
            >
              Edit
            </PlanCard>
          ))}
        </div>
      </Card>

      {modalInput && (
        <PlanEditModal planId={modalInput} handleDismiss={() => setModalInput(undefined)} />
      )}
    </Container>
  );
}
